// extracted by mini-css-extract-plugin
module.exports = {"buttonGoogle":"GoogleAuth_buttonGoogle__2Atuc","googleSvg":"GoogleAuth_googleSvg__3scKA"};